window.PKI = {
  onCertificateExists() {
    if (window.vueRoot) {
      window.vueRoot.$emit('certificate-exists')
    }
  },
  onCsrGenerated(csr) {
    if (window.vueRoot) {
      window.vueRoot.$emit('csr-generated', { csr })
    }
  },
  onCertificateStored() {
    if (window.vueRoot) {
      window.vueRoot.$emit('certificate-stored')
    }
  },
  onSigned(signature) {
    if (window.vueRoot) {
      window.vueRoot.$emit('signed', { signature })
    }
  },
  onFallbackToOtp() {
    if (window.vueRoot) {
      window.vueRoot.$emit('fallback-to-otp')
    }
  },
  onUserCancelled() {
    if (window.vueRoot) {
      window.vueRoot.$emit('user-cancelled')
    }
  },
  onNotAvailable(reason) {
    if (window.vueRoot) {
      window.vueRoot.$emit('not-available', { reason })
    }
  },
  onAuthenticationFailed(reason) {
    if (window.vueRoot) {
      window.vueRoot.$emit('authentication-failed', { reason })
    }
  }
}
